<div class="container" (pointerenter)="pointerEnter()" (pointermove)="pointerMove($event)" (pointerout)="pointerOut()">
	@if (hasAnyErrors) {
		<mat-icon class="warning" svgIcon="acies_information"></mat-icon>
	}

	<div class="hit-layer"></div>
</div>

<div [ngClass]="{ hidden: !showPopup }" #popup class="hover-popup">
	@for (message of errorMessages; track message) {
		<mat-chip-set>
			<mat-chip>{{ getErrorString(message.params) }}</mat-chip>
		</mat-chip-set>
	}
</div>
